<template>
  <img :src="iconMap[type] || iconMap.file" alt="" :style="{ width }" />
</template>

<script>
  import iconMap from '../../images/index.js'

  export default {
    name: 'XFileIcon',
    props: {
      type: {
        type: String,
        default: 'file'
      },
      width: {
        type: String,
        default: '42px'
      }
    },
    data() {
      return {
        iconMap
      }
    }
  }
</script>
